<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'
	export default {
		props: ['user', 'isAuth', 'place'],
		components: {
			'multiselect': Multiselect,
		},
		data () {
			return {
				modal: {
					selector: 'modal-schedule',
				},
				//-- item = task
				item: null,

				usersUnAvailable: [],

				schedule: {
					order_id: null,
					place: null,
					estimated_start: null,
					estimated_end: null,
					task_id: null,
					lang_id: null,
					notification: false,
					users: []
				},

				busy: {
					schedule: false,
					place: false,
				}
			}
		},
		mounted() {
			var that = this
			$('#' + this.modal.selector).on('hidden.bs.modal', function () {
				that.clearData()
			})
		},
		watch: {
			item: function() {
				if(this.item) {
					this.schedule.task_id = this.item.id
					this.schedule.lang_id = this.item.lang_id

					if(this.item.places) {
						if(this.item.places.length) {
							this.schedule.place = this.item.places[0]
						}
					}

					if(this.item.users) {
						if(this.item.users.length == 1) {
							this.schedule.users.push(this.item.users[0])
						}
					}
				}
			},
		},
		methods: {
			open(order = null) {
				this.schedule.order_id = null
				if(order) {
					this.schedule.order_id = order.id
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
				this.clearData()
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			usersChange() {
				this.checkAvailableUsers()
				this.checkAvailableDate()
			},
			estimatedStartChange() {
				this.matchDate()
				this.checkAvailableUsers()
				this.checkAvailableDate()
			},
			estimatedEndChange() {
				this.checkAvailableUsers()
				this.checkAvailableDate()
			},
			checkAvailableUsers() {
				this.usersUnAvailable = []

				var start_date = this.schedule.estimated_start
				var end_date = this.schedule.estimated_end
				
				var users = this.schedule.users
				if(users) {
					for (var i = 0; i < users.length; i++) {
						var user = users[i]
						var unavailable = user.profile.unavailable

						if(unavailable.length) {
							for (var k = 0; k < unavailable.length; k++) {
								var element = unavailable[k]

								var start = moment(element.start_date)
								var end = moment(element.end_date)

								var start_date = moment(start_date)
								var end_date = moment(end_date)

								var betweenStart = start.isBetween(start_date, end_date)
								var isSameStart = start.isSame(start_date)
								var betweenEnd = end.isBetween(start_date, end_date)
								var isSameEnd = end.isSame(end_date)


								if(betweenStart || betweenEnd || isSameStart || isSameEnd) {
									user['unavailable'] = {
										start_date: start,
										end_date: end,
										type: element.type,
									}
									var index = this.usersUnAvailable.indexOf(user)
									if(index < 0) {
										if (typeof user.display_alert == 'undefined') {
											this.usersUnAvailable.push(user)
										}
									}
								} else {
									var betweenStart = start_date.isBetween(start, end)
									var betweenEnd = end_date.isBetween(start, end)

									if(betweenStart || betweenEnd) {
										user['unavailable'] = {
											start_date: start,
											end_date: end,
											type: element.type,
										}
										var index = this.usersUnAvailable.indexOf(user)
										if(index < 0) {
											if (typeof user.display_alert == 'undefined') {
												this.usersUnAvailable.push(user)
											}
										}
									}
								}
							}
						}
					}

					if(this.usersUnAvailable.length) {
						if(this.usersUnAvailable.length) {
							if(this.usersUnAvailable[0]) {
								if (typeof this.usersUnAvailable[0].display_alert == 'undefined') {

									var start_date = moment(this.usersUnAvailable[0].unavailable.start_date).format('DD/MM/YY - H:mm')
									var end_date = moment(this.usersUnAvailable[0].unavailable.end_date).format('DD/MM/YY - H:mm')

									if(this.usersUnAvailable[0].profile.avatar) {
										var imageUrl = this.usersUnAvailable[0].profile.avatar
										var html = '<img class="swal2-image img-circle" src="'+imageUrl+'"width="150" height="150" style="display: block;">'
									} else {
										var html = '<p><i class="fa fa-user-circle-o fa-5x" aria-hidden="true"></i>'
									}

									html += '</p>No disponible</p>' +
									'</p>' + this.usersUnAvailable[0].unavailable.type + ': ' + start_date + ' | ' + end_date + '</p>'

									swal({
										title: this.usersUnAvailable[0].email,
										html: html,
										showCloseButton: true,
										showCancelButton: true,
										confirmButtonText: 'Ignorar',
										confirmButtonColor: "#ff7676",
										cancelButtonColor: '#3085d6',
										cancelButtonText: 'OK',
									})
									.then((result) => {
										this.usersUnAvailable[0].display_alert = false
										this.showAvailableUsers(0)
									})
									.catch((result) => {
										this.showAvailableUsers(0)
									})
								} else {
									this.showAvailableUsers(0)
								}
							}
						}
					} else {
						return null;
					}
				}
			},
			checkAvailableDate() {
				this.busy.schedule = false
				this.busy.place = false

				var that = this
				var start_date = this.schedule.estimated_start

				if(start_date) {
					var estimated_start = moment(start_date)

					if(estimated_start.isValid()) {
						var end_date = this.schedule.estimated_end

						if(end_date) {
							var estimated_end = moment(end_date)

							if(estimated_end.isValid()) {

								this.schedule.users.forEach(function(user) {
									that.$set(user, 'busy', false)
									if(user.schedules) {
										if(user.schedules.length) {
											user.schedules.forEach(function(schedule) {
												that.$set(schedule, 'busy', false)

												if(schedule.place) {
													that.$set(schedule.place, 'busy', false)
												}

												var schedule_start =  moment(schedule.estimated_start)
												var schedule_end =  moment(schedule.estimated_end)

												var betweenStart = estimated_start.isBetween(schedule_start, schedule_end)
												var isSameStart = estimated_start.isSame(schedule_start)
												var betweenEnd = estimated_end.isBetween(schedule_start, schedule_end)
												//var isSameEnd = estimated_end.isSame(schedule_end)

												if(betweenStart || betweenEnd || isSameStart) {
													schedule.busy = true
													that.busy.schedule = true
													user.busy = true

													if(schedule.place) {
														if(that.schedule.place) {
															if(schedule.place.id == that.schedule.place.id) {
																schedule.place.busy = true
																that.busy.place = true
															}
														}
													}
												} else {
													var betweenStart = schedule_start.isBetween(estimated_start, estimated_end)
													var betweenEnd = schedule_end.isBetween(estimated_start, estimated_end)

													if(betweenStart || betweenEnd) {
														schedule.busy = true
														that.busy.schedule = true
														user.busy = true

														if(schedule.place) {
															if(that.schedule.place) {
																if(schedule.place.id == that.schedule.place.id) {
																	schedule.place.busy = true
																	that.busy.place = true
																}
															}
														}
													}
												}
											})
										}
									}
								})
							}
						}
					}
				}
			},
			showAvailableUsers(key) {
				var i = key + 1
				if(this.usersUnAvailable.length) {
					if(this.usersUnAvailable[i]) {
						if(typeof this.usersUnAvailable[i].display_alert == 'undefined') {

							var start_date = moment(this.usersUnAvailable[i].unavailable.start_date).format('DD/MM/YY - H:mm')
							var end_date = moment(this.usersUnAvailable[i].unavailable.end_date).format('DD/MM/YY - H:mm')

							if(this.usersUnAvailable[i].profile.avatar) {
								var imageUrl = this.usersUnAvailable[i].profile.avatar
								var html = '<img class="swal2-image img-circle" src="'+imageUrl+'"width="150" height="150" style="display: block;">'
							} else {
								var html = '<p><i class="fa fa-user-circle-o fa-5x" aria-hidden="true"></i>'
							}

							html += '</p>No disponible</p>' +
							'</p>' + this.usersUnAvailable[i].unavailable.type + ': ' + start_date + ' | ' + end_date + '</p>'

							swal({
								title: this.usersUnAvailable[i].email,
								html: html,
								showCloseButton: true,
								showCancelButton: true,
								confirmButtonText: 'Ignorar',
								confirmButtonColor: "#ff7676",
								cancelButtonColor: '#3085d6',
								cancelButtonText: 'OK',
							})
							.then((result) => {
								this.usersUnAvailable[i].display_alert = false
								this.showAvailableUsers(i)
							})
							.catch((result) => {
								this.showAvailableUsers(i)
							})
						} else {
							this.showAvailableUsers(i)
						}
					}
				}
			},
			matchDate: function() {
				if(!this.schedule.estimated_end) {
					this.schedule.estimated_end = this.schedule.estimated_start
				}
			},
			clearData: function() {
				this.schedule.estimated_start = null
				this.schedule.estimated_end = null
				this.schedule.users = []
			},
			editContinue(data) {
				var that = this
				if(this.user.hasRole('staff')) {
					swal({
						title: data.body.title,
						text: data.body.text,
						type: data.body.type,
					})
				} else {
					swal({
						title: data.body.title,
						text: data.body.text,
						type: data.body.type,
						showCancelButton: true,
						confirmButtonColor: '#2cabe3',
						confirmButtonText: 'Editar tarea',
						cancelButtonText: 'Continuar',
					}).then(function () {
						that.close()
						that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/projects/tasks/' + that.item.id + '/edit')
						that.clearData()
					}).catch(function() {
						that.close()
						that.clearData()
					})
				}
			},
			notification(data) {
				var that = this
				swal({
					title: this.$t("messages.notify"),
					text: this.$t("messages.notify_the_task_staff_by_email"),
					type: 'info',
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function () {
							that.$http.get('admin/projects/tasks/'+ data.body.data.task_id +'/notification/mail')
								.then(response => {
									if(response.body) {
										that.$emit('reload')
										that.item.locked = response.body.locked
										that.item.trace = response.body.trace

										if(that.user.hasRole('staff')) {
											swal({
												title: that.$t("messages.done"),
												text: that.$t("messages.notifications_sent_correctly"),
												type: 'success',
											})
										} else {
											swal({
												title: that.$t("messages.done"),
												text: that.$t("messages.notifications_sent_correctly"),
												type: 'success',
												showCancelButton: true,
												confirmButtonColor: '#2cabe3',
												confirmButtonText: 'Editar tarea',
												cancelButtonText: 'Continuar',
											}).then(function () {
												that.close()
												that.$router.push('/' + this.$platform.slug + '/' + that.$i18n.locale + '/admin/projects/tasks/'+data.body.data.task_id+'/edit')
											}).catch(function() {
												that.close()
											})
										}
									}
								}).catch(function(response) {
									console.log(response)
								})
						})
					}
				}).catch(function() {
					that.editContinue(data)
				})
			},
			store: function() {
				this.formatData()
				if(!this.busy.place) {
					var loading = Ladda.create(this.$refs.btnStore)
					loading.start()
					this.$http.post('admin/projects/schedules', this.schedule)
					.then(response => {
						var data = response
						loading.stop();
						var that = this;
						this.close()
						this.$emit('reload')
						if(this.schedule.users.length) {
							this.notification(response)
						} else {
							this.editContinue(response)
						}
					}).catch(function(response) {
						loading.stop()
						console.log(response)
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning",
						})
					})
				}
			},
			dateUnavailable (unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return start.format('DD/MM/YYYY - H:mm') + ' | ' + end.format('DD/MM/YYYY - H:mm')
						}
					}
				}
			},
			typeUnavailable(unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return element.type
						}
					}
				}
			},
			openPopoverDate(id) {
				var popover = $('#popover-'+id)
				popover.popover('toggle')
			},
			formatData() {
				if(this.schedule.estimated_start) {
					var estimated_start = moment(this.schedule.estimated_start)
					this.schedule.estimated_start = estimated_start.format('YYYY-MM-DD H:mm:ss')
				}
				if(this.schedule.estimated_end) {
					var estimated_end = moment(this.schedule.estimated_end)
					this.schedule.estimated_end = estimated_end.format('YYYY-MM-DD H:mm:ss')
				}
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/schedules/views/Create.vue